import { render, staticRenderFns } from "./DetailAuthor.vue?vue&type=template&id=9610c5b4&scoped=true"
import script from "./DetailAuthor.vue?vue&type=script&lang=js"
export * from "./DetailAuthor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9610c5b4",
  null
  
)

export default component.exports